export const modalSelector = (state) => ({
  modal: state.modals
});
